<template>
  <div>
    <b-table class="table-sm text-center" responsive outlined hover head-variant="light" :no-local-sorting=true
      :busy="loading" :sort-by.sync="filters.sort_field" :sort-desc.sync="filters.sort_order" :fields="tableFields"
      :items="labelSetSamples">
      <template v-slot:cell(id)="{ value }">
        <b-form-checkbox :checked="selectedSamples.includes(value)"
          @click.native.prevent="$emit('toggleSelectSample', value, $event)"
          @keyup.native.space="$emit('toggleSelectSample', value, $event)" class="me-2 noselect">
          {{ value }}
        </b-form-checkbox>
      </template>
      <template v-slot:cell(name)="{ item }">
        <b-badge v-if="item.label_object_sets && item.label_object_sets[0] && item.label_object_sets[0].is_verified"
          variant="success">
          {{ $dt('label__set_samples_list.is_verified_badge', 'Is Verified') }}
        </b-badge>
        {{ item.name }}
      </template>
      <template v-slot:cell(label_objects)="{ item }">
        <template v-if="item.label_object_sets && item.label_object_sets[0] && item.label_object_sets[0].label_objects">
          <b-badge variant="primary" data-toggle="tooltip" title="Label object tag"
            v-for="tag in allLabelObjectTags(item.label_object_sets[0].label_objects)" :key="tag" class="mx-1">{{ tag
            }}</b-badge>
          <b-badge data-toggle="tooltip" title="Label object set tag" v-for="tag in item.label_object_sets[0].tags_data"
            :key="`lss${tag.id}`" class="mx-1 label-object-set-tag">{{ tag.name }}</b-badge>
        </template>
        <b-badge variant="secondary" data-toggle="tooltip" title="Sample tag" v-for="tag in item.tags_data"
          :key="`s${tag.id}`" class="mx-1">{{ tag.name }}</b-badge>
        <b-badge data-toggle="tooltip" title="Sample set tag" v-for="tag in item.sample_set_tags" :key="`ss${tag.id}`"
          class="mx-1 light-tag">{{ tag.name }}</b-badge>
      </template>
      <template v-slot:cell(files)="row">
        <SvgPreviewSlider :item="row.item" />
      </template>

      <template v-slot:cell(lso_updated)="row">
        {{ momentf(row.item.label_object_set_last_updated) }}
        <div v-for="activity in row.item.activities" :key="activity.id">
          <b-badge>
            {{ activity.email }}<br />
            {{ momentf(activity.created_at) }}<br />
            {{ activity.description }}
          </b-badge>
        </div>
        <!-- <FilePreview v-for="file in row.item.files" :key="file.id" :file="file" :set_id="row.item.sample_set_id" /> -->
      </template>
      <template v-slot:cell(options)="row">
        <div class="flex-container options-center">
          <router-link :to="{
            name: 'LabelSample',
            query: { filter: JSON.stringify(queryParams) },
            params: { project_id: row.item.project_id, sample_id: row.item.id, label_set_id: label_set_id }
          }">
            <a><i class="mx-1 fa fa-paint-brush fa-lg" /></a>
          </router-link>
          <!-- <router-link v-if="row.item.actions.update" :to="{ name: 'SampleUpdate', params:{ project_id: row.item.project_id, sample_set_id: row.item.sample_set_id, id: row.item.id }}">
          <a><i class="mx-1 fa fa-edit fa-lg"/></a>
        </router-link> -->
          <!-- <Delete v-if="row.item.actions.delete"  :id="row.item.id" @deleted="getData" :deleteFn="()=>deleteFn(row.item.project_id,row.item.sample_set_id,row.item.id)" /> -->
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
// import FilePreview from '@/views/Shared/FilePreview.vue';
import SvgPreviewSlider from '@/views/Shared/SvgPreviewSlider.vue';

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    labelSetSamples: {
      value: Array,
      required: true
    },
    label_set_id: {
      type: Number,
      required: true
    },
    selectedSamples: {
      value: Array,
      required: true
    },
    filtersSortOrder: {
      value: String,
      required: true
    },
    filtersSortField: {
      value: String,
      required: true
    },
    queryParams: {
      value: Object,
    }
  },
  data() {
    return {
      filters: {
        sort_field: this.filtersSortField,
        sort_order: this.filtersSortOrder,
      },
      tableFields: [
        {
          key: 'id', sortable: true, label: this.$t('global.id'), tdClass: 'text-left'
        },
        {
          key: 'name', sortable: true, label: this.$t('sample.name'), tdClass: 'text-left'
        },
        { key: 'label_objects', sortable: false, label: this.$t('sample.label_objects') },
        // { key: 'files', sortable: true, label: this.$t('sample.files') },
        // { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
        { key: 'lso_updated', sortable: true, label: this.$t('global.updated_at') },
        { key: 'files', sortable: false, label: this.$t('sample.files') },
        { key: 'options', label: this.$t('global.options') }
      ],
    };
  },
  watch: {
    filters: { deep: true, handler: 'changeFilters' }
  },
  components: {
    SvgPreviewSlider,
  },
  computed: {
    selectedSamplesRO: {
      get() { return this.selectedSamples; }, set() { }
    }
  },
  methods: {
    isSampleSelected(sampleId) {
      return this.selectedSamples.includes(sampleId);
    },
    changeFilters() {
      setTimeout(() => {
        this.$emit('changeFilters', this.filters);
      }, 10);
    },
    allLabelObjectTags(labelObjects) {
      const allTags = [];
      labelObjects.forEach((object) => {
        object.tags_data.forEach((tag) => {
          if (!allTags.includes(tag.name)) {
            allTags.push(tag.name);
          }
        });
      });
      return allTags;
    }
  }
};
</script>
<style lang=scss>
.light-tag {
  background-color: white;
  border: solid 1px $secondary;
  color: $secondary;
}

.label-object-set-tag {
  background-color: white;
  border: solid 1px $primary;
  color: $primary;
}

.noselect {
  user-select: none;
}
</style>
